import { motion } from "framer-motion";
import { Reveal, EASE } from "./Reveal";
import { ABOUT, STUDIO } from "../data/siteContent";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* Image composition */}
        <div className="relative">
          <Reveal>
            <div className="relative overflow-hidden">
              <motion.img
                src={ABOUT.images.tall.src}
                alt={ABOUT.images.tall.alt}
                loading="lazy"
                className="w-full aspect-[4/5] object-cover"
                whileHover={{ scale: 1.04 }}
                transition={{ duration: 1.2, ease: EASE }}
              />
            </div>
          </Reveal>
          <Reveal delay={0.2} className="absolute -bottom-10 -right-2 sm:-right-6 w-1/2 sm:w-[45%]">
            <div className="border border-gold/25 p-2 bg-ink">
              <img
                src={ABOUT.images.wide.src}
                alt={ABOUT.images.wide.alt}
                loading="lazy"
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
          </Reveal>
          <Reveal
            delay={0.35}
            className="absolute -top-5 -left-2 sm:-left-5 border border-gold/40 bg-ink/90 backdrop-blur px-5 py-4"
          >
            <p className="font-display italic text-2xl text-gold leading-none">Since the</p>
            <p className="font-display italic text-2xl text-gold">film-roll days</p>
          </Reveal>
        </div>

        {/* Story */}
        <div className="pt-10 lg:pt-0">
          <Reveal className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-gold/50" />
            <span className="eyebrow">{ABOUT.eyebrow}</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-ivory mb-6">
              {ABOUT.title}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-lg sm:text-xl font-light text-ivory-dim leading-relaxed mb-6">
              {ABOUT.lead}
            </p>
          </Reveal>
          {ABOUT.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.28 + i * 0.1}>
              <p className="text-base text-ivory-dim/90 leading-relaxed mb-5">{p}</p>
            </Reveal>
          ))}

          <Reveal delay={0.45} className="flex flex-wrap gap-3 mt-4 mb-8">
            {ABOUT.chips.map((c) => (
              <span
                key={c}
                className="text-xs uppercase tracking-[0.14em] text-ivory-dim border border-white/10 px-4 py-2"
              >
                {c}
              </span>
            ))}
          </Reveal>

          <Reveal delay={0.55}>
            <blockquote className="border-l-2 border-gold pl-6 py-1">
              <p className="font-display italic text-2xl sm:text-3xl text-gold leading-snug">
                “{ABOUT.quote}”
              </p>
              <p className="text-xs uppercase tracking-[0.25em] text-ivory-mute mt-2">
                {ABOUT.quoteMeaning} — {STUDIO.name}, {STUDIO.city}
              </p>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
